<template>
    <form-container header="Akışlar" v-on:save="save" :disabled="loading">
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label>{{translate('circulationProfileSchema.flowName')}}</label>
                    <input @input="checkInput('Name',$event)" v-model="data.Name" type="text" class="form-control" required />
                </div>
                <div class="form-group">
                    <label>{{translate('circulationProfileSchema.department')}}</label>
                    <select-input
                        :value="data.DepartmentId"
                        :autocomplete="true"
                        :placeholder="translate('search')"
                        :items="availableDepartments"
                        :isDisabled="setDepartmentDisabled()"
                        :filter-function="(item, search) => new RegExp(search, 'i').test(item.Name)"
                        @change="departmentSelectChanged"
                        style="width:100%;">
                            <span v-if="data.DepartmentId">
                                {{selectedDepartment.Name}}
                            </span>
                            <span v-else>{{translate('circulationProfileSchema.allDepartmentsCanAccess')}}</span>
                            <template v-slot:item="{item}">
                                <div style="padding:2px 0;">
                                    {{item.Name}}
                                </div>
                            </template>
                    </select-input>
                    <small class="text-muted">{{translate('circulationProfileSchema.onlyForSelectedDepartments')}}</small>
                </div>
                <div class="form-group">
                    <label>{{translate('circulationProfileSchema.targetSystems')}}</label>
                    <select-multiple :key="data.DepartmentId" :required="true" :autocomplete="true" v-model="data.TargetSystemIds" :list="availableTargetSystems" style="height:185px;"></select-multiple>
                </div>
                <div class="form-group form-check">
                    <input type="checkbox" class="form-check-input" v-model="data.IsActive" id="isActive"/>
                    <label class="form-check-label" for="isActive">{{translate('targetSystemImport.active')}} - <small class="text-muted">{{translate('circulationProfileSchema.isActiveText')}}</small></label>
                </div>
            </div>
            <div class="col-md-6">
                <label>{{translate('circulationProfileSchema.steps')}}</label>
                <step-editor ref="stepEditor" :key="data.DepartmentId" v-model="data.Steps" :user-list="availableUserList" :editable="true" class="form-control" style="height:380px; overflow-y:auto; padding: 16px 16px 16px 0;"></step-editor>
                <button type="button" class="btn btn-sm btn-outline-secondary float-right" @click="$refs.stepEditor.addStep()" style="margin-top:12px;"><icon-plus/> {{translate('circulationProfileSchema.addStep')}}</button>
            </div>
        </div>
        <template v-slot:footer>
            <div class="row">
                <div class="col">
                    <button type="button"  v-on:click="goBack" class="btn btn-outline-primary">{{translate('goBack')}}</button>
                </div> 
                <div class="col text-right mlxs">
                    <button type="submit" class="btn btn-success">{{translate('save')}}</button>
                </div>
            </div>
        </template>

    </form-container>
</template>

<script>
import formMixin from '../formMixin.js';
import formContainer from '../components/FormContainer.vue'
import stepEditor from '../components/StepEditor.vue'
import selectMultiple from '../components/SelectMultiple.vue'
import selectInput from '../components/SelectInput.vue'
import iconPlus from '../components/Icons/plus.svg';


export default {
    mixins: [formMixin],
    components: {
        stepEditor,
        formContainer,
        iconPlus,
        selectMultiple,
selectInput

        //stepViewer
    },
    created(){
        this.getDepartments({predicate: "IsActive= true" })
        .then(x => {
            this.departments = x.Result;
        }).catch(x => {
            console.log("Departman listesi yüklenemedi:", x);
        });

        this.getTargetSystems()
        .then(x => {
            this.targetSystems = x.Result;
        }).catch(x => {
            console.log("Alıcı listesi yüklenemedi:", x);
        });

        this.getUsers({predicate: "IsActive= true" })
        .then(x => {
            this.userList = x.Result;
        }).catch(x => {
            console.log('Kullanıcı listesi yüklenemedi:', x);
        })

        this.getData(this.$route.params.id);
    },
    data() {
        return {
            loading: false,
            modelName: 'CirculationProfileSchema',
            data: {},
            backupSteps: null,
            userList: null,
            targetSystems: null,
            departments: null
        }
    },
    methods: {
        checkInput(value, event) {
            // Check for invalid characters
            if (/[<>]/.test(event.target.value)) {
                alert(this.translate('errors.invalidSymbols'))
                const editedText = ""
                this.$set(this.data, value, editedText)
            } else {
                this.$set(this.data, value, event.target.value)
            }
        },
         departmentSelectChanged(value){
            this.data.DepartmentId = value?.Id;
            this.$forceUpdate();
        },
        isNewRecord(){
           if(this.$route.params.id == "000000000000000000000000")
               return true;
            return false;
        },
        setDepartmentDisabled(){
            if(this.isNewRecord())
                return false;
            if(this.hasAuth('Admin') || (this.$root.$data.login.User.DepartmentIds ?? []).length == 0)
                return false;
            if(this.data.DepartmentId)
                return false;
            return true;
        }
    },
    computed: {
        selectedDepartment(){
            return this.departments?.filter(x => x.Id == this.data.DepartmentId)[0];
        },
        availableUserList(){
            if(!this.userList)
                return [];

            if(!this.data.DepartmentId)
                return this.userList;

            return this.userList.filter(x => x.Departments == null || x.Departments.length == 0 || x.Departments.some(d => d.Id == this.data.DepartmentId));
        },
        availableTargetSystems(){
            // Bu dolaşım profilinde seçili departmana göre hedef sistemleri filteler
            if(!this.targetSystems)
                return [];

            if(!this.data.DepartmentId)
                return this.targetSystems.filter(x => !x.Department);

            return this.targetSystems.filter(x => !x.Department || x.Department?.Id == this.data.DepartmentId);
        },
        availableDepartments(){
            var result = (this.departments ?? []).filter(x => x.IsActive);

            if(this.hasAuth('Admin') || (this.$root.$data.login.User.DepartmentIds ?? []).length == 0)
                result =  [{Id:'', Name: this.translate('circulationProfileSchema.allDepartmentsCanAccess')}].concat(result);

            return result;
        }
    }
}
</script>